import Vue from 'vue';
import Vuex from 'vuex';

import rooms from './modules/rooms';
import guides from './modules/guides';

Vue.use(Vuex);

const store = new Vuex.Store({
    modules: {
        rooms,
        guides,
    },
    strict: true,
});

export default store;